import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Paper,
  Typography,
  Icon,
  Button,
} from '@material-ui/core';
import { TenantService } from '@pingum/api-services';
import { getTenantFromUrl } from '../../../utils/urlHelper';
import styles from './styles';

const tenantUrl = TenantService.getTenantUrl(getTenantFromUrl());

export const DeactivatedOrganizationPageComponent = ({ classes }) => (
  <div className={classes.container}>
    <div className={classes.content}>
      <Paper className={classes.root} elevation={10}>
        <Icon className={classes.icon}>
          block
        </Icon>
        <Typography
          variant="h3"
          align="center"
        >
          Organization Deactivated
        </Typography>
        <Typography variant="subtitle1" align="center" gutterBottom>
          This organization has been deactivated and cannot be accessed.
        </Typography>
        <Typography variant="body2" align="center" gutterBottom>
          Please contact support to reactivate this organization
          <br />
          <span>Organization URL: <strong><span href={tenantUrl}>{tenantUrl}</span></strong></span>.
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            color="primary"
            size="small"
            href="mailto:support@pingum.io?Subject=Reactivate%20Organization"
            target="_top"
            variant="contained"
          >
            Contact Support
          </Button>
        </div>
      </Paper>
    </div>
  </div>
);

DeactivatedOrganizationPageComponent.propTypes = { classes: PropTypes.object };
DeactivatedOrganizationPageComponent.defaultProps = { classes: {} };

export default withStyles(styles, { withTheme: true })(DeactivatedOrganizationPageComponent);
